module.exports = __webpack_public_path__ + "h5/img/skill_title.2b3f3a66.png";